import { occupationProxy } from '@/components/DynamicFlow/utils/constants';

const getOccupations = async (): Promise<any> => {
  try {
    const response = await fetch(occupationProxy, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch occupation data: ${response.status} ${response.statusText}`,
      );
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching occupations:', error);
    throw error;
  }
};

export default getOccupations;
